import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "../lib/api.js";
import { planFeaturesFromEntitlements } from "../lib/planFeatures.js";

export type WorkspaceBillingSnapshot = {
  planKey: string;
  entitlements: Record<string, unknown>;
  upgradePrompts: string[];
};

export type { PlanFeatures } from "../lib/planFeatures.js";

export const useWorkspaceBilling = (workspaceId: string | null) => {
  const query = useQuery({
    queryKey: ["billing", workspaceId],
    enabled: workspaceId !== null,
    queryFn: async (): Promise<WorkspaceBillingSnapshot> => {
      const res = await apiFetch(`/admin/workspaces/${workspaceId}/billing`);
      if (!res.ok) {
        throw new Error("billing_load_failed");
      }
      return (await res.json()) as WorkspaceBillingSnapshot;
    },
    staleTime: 60_000
  });

  const features = planFeaturesFromEntitlements(query.data?.entitlements);

  return {
    ...query,
    planKey: query.data?.planKey ?? null,
    features,
    upgradePrompts: query.data?.upgradePrompts ?? []
  };
};
